export default {
  /* eslint-disable no-unused-vars */

  maturityBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        barPercentage: 0.2,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                  return label;
              }

          },
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  maturityBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        borderWidth: 1,
        barPercentage: 0.2,
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Years'
          }
        },]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  ratingBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#7E6990",
        borderWidth: 1,
        barPercentage: 0.2
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }

        }],
        xAxes: [{

          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  ratingBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#7E6990",
        borderWidth: 1,
        barPercentage: 0.2

      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Rating'
          }
        }]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  spRatingBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#7E6990",
        borderWidth: 1,
        barPercentage: 0.2
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }

        }],
        xAxes: [{

          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  spRatingBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#7E6990",
        borderWidth: 1,
        barPercentage: 0.2

      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Rating'
          }
        }]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  pieChartDefault: {
    type: 'doughnut',
    data: {
      labels: [],
      datasets: [{
        backgroundColor: [
          "#7E6990",
          "#FF9E47"
        ],
        data: []
      }]
    },
    options: {
      cutoutPercentage: 40,
      legend: {
        position: "right",
        align: "middle"
      },
      tooltips: {
        enabled: true
      },
      plugins: {
        labels: {
          render: 'percentage',
          fontColor: ['white', 'white'],
          precision: 2,
          fontSize: 10,
        },
        
      } 
    }

  },
  pieChartDefaultPopup: {
    type: 'doughnut',
    data: {
      labels: [],
      datasets: [{
        backgroundColor: [
          "#7E6990",
          "#FF9E47"
        ],
        data: []
      }]
    },
    options: {
      legend: {
        position: "right",
        align: "middle"
      },
      plugins: {
        labels: {
          render: 'percentage',
          fontColor: ['white', 'white'],
          precision: 2
        }
      } 
    }
  },
  geoMapDefault: {
    type: "choropleth",
    data: {
      labels: [],
      datasets: [{
        label: "States",
        outline: [],
        data: []
      }]
    },
    options: {
      legend: {
        display: false
      },
      scale: {
        projection: "albersUsa"
      },
      geo: {
        colorScale: {
          display: true,
          position: "bottom",
          quantize: 5,
          legend: {
            position: "bottom-right"
          }
        }
      }
    }
  },
  geoMapDefaultPopUp: {
    type: "choropleth",
    data: {
      labels: [],
      datasets: [{
        label: "States",
        outline: [],
        data: []
      }]
    },
    options: {
      legend: {
        display: false
      },
      scale: {
        projection: "albersUsa"
      },
      geo: {
        colorScale: {
          display: true,
          position: "bottom",
          quantize: 5,
          legend: {
            position: "bottom-right"
          }
        }
      }
    }
  },
  insuranceBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#56B68B",
        borderWidth: 1,
        barPercentage: 0.2

      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            // Create scientific notation labels
            callback: function (value) {
              return value.match(/\b(\w)/g).join('');
            }
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  insuranceChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#56B68B",
        borderWidth: 1,
        barPercentage: 0.2

      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
           
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            // Create scientific notation labels
            callback: function (value) {
              return value.match(/\b(\w)/g).join('');
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Insurance'
          }
        }]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  purposeChartDefault: {
    type: "treemap",
    data: {
      datasets: [{
        label: "",
        tree: [],
        key: "count",
        groups: ["label"],
        fontColor: "white",
        //   backgroundColor: function (ctx) {
        //     if (ctx.dataset.data.length <= ctx.dataIndex) {
        //       return undefined;
        //     }
        //     return colorFromValue(ctx.dataset.data[ctx.dataIndex].v);
        //   },
        //   borderColor: function (ctx) {
        //     return colorFromValue(ctx.dataset.data[ctx.dataIndex], true);
        //   },
       // spacing: 0.1,
       // borderWidth: 2,
        //borderColor: "rgba(180,180,180, 0.15)"
      }]
    },
    options: {
      maintainAspectRatio: false,
      title: {
        display: false,
      },
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          title: function (item, data) {
            //return data.datasets[item[0].datasetIndex].key;
          },
          label: function (item, data) {
            var dataset = data.datasets[item.datasetIndex];
            var dataItem = dataset.data[item.index];
            var obj = dataItem._data;
            var label = obj.label;
            return  label + ': '+ dataItem.v;
          }
        }
      }
    }
  },
  purposeChartDefaultPopup: {
    type: "treemap",
    data: {
      datasets: [{
        label: "",
        tree: [],
        key: "count",
        groups: ["label"],
        fontColor: "white",
        fontFamily: "Optima",
        //fontSize: 20,
        //   backgroundColor: function (ctx) {
        //     if (ctx.dataset.data.length <= ctx.dataIndex) {
        //       return undefined;
        //     }
        //     return colorFromValue(ctx.dataset.data[ctx.dataIndex].v);
        //   },
        //   borderColor: function (ctx) {
        //     return colorFromValue(ctx.dataset.data[ctx.dataIndex], true);
        //   },
        spacing: 0.1,
        borderWidth: 2,
        //borderColor: "rgba(180,180,180, 0.15)"
      }]
    },
    options: {
      maintainAspectRatio: false,
      title: {
        display: false

      },
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          title: function (item, data) {
           // return data.datasets[item[0].datasetIndex].key;
          },
          label: function (item, data) {
            var dataset = data.datasets[item.datasetIndex];
            var dataItem = dataset.data[item.index];
            var obj = dataItem._data;
            var label = obj.label;
            return  label + ': '+ dataItem.v;
          }
        }
      }
    }
  },
  couponBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#2f4857",
        barPercentage: 0.1,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  couponBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#2f4857",
        borderWidth: 1,
        barPercentage: 0.1,
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Coupon'
          }
        }]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  callChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#292929",
        barPercentage: 0.1,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Years'
          }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  stateBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        barPercentage: 0.2,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                  return label;
              }

          },
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            autoSkip: false
         }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  stateBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        borderWidth: 1,
        barPercentage: 0.2,
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'States'
          },
          ticks: {
            autoSkip: false
         }
        },]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  purposeBarChartDefault: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        barPercentage: 0.2,
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                  return label;
              }

          },
          }

        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            autoSkip: false
         }
        }, ]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },
  purposeBarChartDefaultPopup: {
    type: 'bar',
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        backgroundColor: "#0084CC",
        borderWidth: 1,
        barPercentage: 0.2,
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: 'Count of CUSIP'
          }
        }],
        xAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          scaleLabel: {
            display: true,
            labelString: 'Purposes'
          },
          ticks: {
            autoSkip: false
         }
        },]
      },
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: function (args) {
            return '';
          },
        }
      } 
    }
  },


}